import * as CONSTANTS from '../constants/constants';

const initialState = {
  uploadSuccess: null,
  uploadError: null,
  loading: false,
  uploadCatSuccess: null,
  uploadCatError: null,
  deleteSuccess: null,
  deleteError: null,
  editCatSuccess: null,
  editCatError: null,
  editPostSuccess: null,
  editPostError: null,
  uploadcommentSuccess: null
};

const postReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.REFRESH_COMMENTS:
      return Object.assign({}, state, {
        uploadcommentSuccess: true
      });
    case CONSTANTS.SET_LOADING_POST:
      return Object.assign({}, state, {
        loading: true
      });
    case CONSTANTS.UPLOAD_POST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        uploadSuccess: CONSTANTS.UPLOAD_POST_SUCCESS_MSG
      });
    case CONSTANTS.UPLOAD_POST_ERROR:
      return Object.assign({}, state, {
        loading: false,
        uploadError: CONSTANTS.UPLOAD_POST_ERROR_MSG
      });
    case CONSTANTS.UPLOAD_POST_RESET_MSGS:
      return Object.assign({}, state, {
        uploadSuccess: null,
        uploadError: null,
        editPostSuccess: null,
        editPostError: null,
      });
    case CONSTANTS.SET_LOADING_POSTCAT:
      return Object.assign({}, state, {
        loading: true
      });
    case CONSTANTS.UPLOAD_POSTCAT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        uploadCatSuccess: CONSTANTS.UPLOAD_POSTCAT_SUCCESS_MSG
      });
    case CONSTANTS.UPLOAD_POSTCAT_ERROR:
      return Object.assign({}, state, {
        loading: false,
        uploadCatError: CONSTANTS.UPLOAD_POSTCAT_ERROR_MSG
      });
    case CONSTANTS.EDIT_POSTCAT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        editCatSuccess: CONSTANTS.EDIT_POSTCAT_SUCCESS_MSG
      });
    case CONSTANTS.EDIT_POSTCAT_ERROR:
      return Object.assign({}, state, {
        loading: false,
        editCatError: CONSTANTS.EDIT_POSTCAT_ERROR_MSG
      });
      case CONSTANTS.EDIT_POST_SUCCESS:
        return Object.assign({}, state, {
          loading: false,
          editPostSuccess: CONSTANTS.EDIT_POST_SUCCESS_MSG
        });
      case CONSTANTS.EDIT_POST_ERROR:
        return Object.assign({}, state, {
          loading: false,
          editPostError: CONSTANTS.EDIT_POST_ERROR_MSG
        });
    case CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS:
      return Object.assign({}, state, {
        uploadCatSuccess: null,
        uploadCatError: null,
        editCatSuccess: null,
        editCatError: null,
      });
    case CONSTANTS.DELETE_POST_SUCCESS:
      return Object.assign({}, state, {
        deleteSuccess: CONSTANTS.DELETE_POST_SUCCESS_MSG
      });
    case CONSTANTS.DELETE_POST_RESET_MSGS:
      return Object.assign({}, state, {
        deleteSuccess: null,
        deleteError: null,
      });
    default:
      return state;
  }
}

export default postReducer;